import { SharedLink } from '@/types';

export const demoSharedLinks: SharedLink[] = [
  {
    id: 'link1',
    type: 'add',
    targetId: 'child1',
    token: 'demo-add-link',
    createdAt: Date.now() - 86400000, // 1 day ago
    isActive: true,
    useCount: 0,
    maxUses: 1
  },
  {
    id: 'link2',
    type: 'info',
    targetId: 'child2',
    token: 'demo-info-link',
    createdAt: Date.now() - 172800000, // 2 days ago
    isActive: true,
    useCount: 0
  }
];